<script type="text/ecmascript-6">
    import DesignerQuestionGlassDesign from "../DesignerQuestionGlassDesign.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionGlassDesign,
            SynsealTileQuestion,
        ],
        props: {
            title: {
                default(){
                    return 'Door Glass Design';
                }
            },
        }
    }
</script>
